export default {
  media: 'Media',
  article: 'Article',
  mixed: 'Mixed',
  teaser: 'Teaser',
  slide: 'Slide',
  brand: 'BrandSlider',
  followedBrand: 'FollowedBrand',
};
